import React, { useEffect, useState } from 'react';
import './Home.css';
import { AuthContext } from '../../context/AuthContext.js';

const HomeComponent: React.FC = () => {
    const authContext = React.useContext(AuthContext);
    if (!authContext) {
        throw new Error('LoginScreen must be used within an AuthProvider');
    }
    const { token } = authContext;

    const homeScreenEntries: string[] = ["Hi Schatzi!"];

    return (
        <div>
            {homeScreenEntries.map((entry, index) => (
                <div key={`home-entry-${index}`}>
                    <p>{entry}</p>
                </div>
            ))}
            {/* {homeCards.map(card => (
                <HomeCardComponent key={`home-cards-${card.id}`} content={card.HomeCardContent} />
            ))} */}
        </div>
    );
};

export default HomeComponent;